import angular from 'angular';
import sectionsLibraryService from './../../../SectionsLibraryService';
import toolbarService from './../../../../Toolbar/ToolbarService';
import ConfigParameter from "../../../../ConfigParameters/ConfigParameter";
import Align from "../../../../ConfigParameters/ConfigParameters/Align";
import Paddings from "../../../../ConfigParameters/ConfigCollections/Paddings";
import SizeWidth from "../../../../ConfigParameters/ConfigParameters/SizeWidth";
import Video from "../../../../ConfigParameters/ConfigParameters/Video";
import './video.scss';
import CustomClassName from "../../../../ConfigParameters/ConfigParameters/CustomClassName";

const MODULE_NAME = 'pageVideo';

const creatorPageSectionVideo = {
    bindings: {
        elementModel: '=',
        uid: '<',
    },
    template: require('./video.html'),
    controller: function (ToolbarService, $sce) {

        let defaultConfig = ToolbarService.getSectionDefaultSchema(MODULE_NAME);

        this.$onInit = () => {
            this.elementModel = angular.copy(angular.extend(defaultConfig, this.elementModel));
        };

        this.url = () => {
            return $sce.trustAsResourceUrl( this.elementModel.video.data)
        };
    }

};

export default angular.module('cms.creator.page.section-video', [sectionsLibraryService, toolbarService])
    .run(function (SectionsLibraryService, ToolbarService, gettext, UniqueIdGenerator) {

        SectionsLibraryService.registerSection({
            icon: 'video_library',
            type: MODULE_NAME,
            label: gettext('Video'),
            group: 'page',
            groups: {
                mainConfig: {
                    label: gettext('Main config'),
                    isOpen: true,
                    type: 'mainConfig'
                },
                position: {
                    label: gettext('Position'),
                    isOpen: false,
                    type: 'position'
                },
                advanced: {
                    label: gettext('Advanced'),
                    isOpen: false,
                    type: 'advanced'
                }
            }
        });

        let sizeWidth = new SizeWidth();
        sizeWidth.setDefaultValue({value:100, unit:'%'});

        ToolbarService.registerSectionSchema(MODULE_NAME, {
            ...(new ConfigParameter('sectionId', 'hidden', gettext('Section Id'), null, (type) => UniqueIdGenerator.generate(type))),
            ...(new ConfigParameter('uid', 'hidden', '', null, () => UniqueIdGenerator.generate('element-uid'))),
            ...(new Video()),
            ...(new Align),
            ...(new Paddings()),
            ...sizeWidth,
            ...(new CustomClassName())
        });

    })
    .component('cmsCreatorPageSectionVideo', creatorPageSectionVideo).name;




// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/Sections/Page/Video/Video.js